import { ConsultantsQueryPsykologInput, SelectType } from "@graphql";

export const psykologInitialValues: ConsultantsQueryPsykologInput = {
  experience: {
    type: SelectType.ANY,
    value: []
  },
  methods: {
    type: SelectType.ANY,
    value: []
  }
};
